import { Component } from '@angular/core';

@Component({
  selector: 'craft-notification-overlay',
  templateUrl: './notification-overlay.component.html',
  styleUrls: ['./notification-overlay.component.scss'],
})
export class NotificationOverlayComponent {}
